<template>
  <div class="p-8 border-2 border-dashed border-gray-300 rounded-lg text-center">
    <h3 class="text-xl font-bold mb-4">
      Server Calculator Placeholder
    </h3>
    <p class="text-gray-500">
      We'll build this calculator later.
    </p>
  </div>
</template>
